<template>
  <div class="classDetail w100 pl20 pr20 pt20 pb20">
      <!-- <div><el-button type="primary" plain @click="$router.go(-1)">返回</el-button></div> -->
      <!-- <div style="width: 100%;text-align: center;font-size: 18px;font-weight: bold;">课堂详情-评教</div> -->

    <el-tabs v-model="activeName">
      <el-tab-pane label="基本信息" name="first">
        <basic :info="info"/>
      </el-tab-pane>
      <el-tab-pane label="评教" name="second">
        <evaluation :info="info"/>
      </el-tab-pane>
      <el-tab-pane label="考勤" name="third">
        <attendance :info="info"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import basic from './basic.vue'
import evaluation from './evaluation.vue'
import attendance from './attendance.vue'

  export default {
    props: {
      info: {
        type: Object,
        default () {
            return {};
        }
      },
    },
    components: {
      basic,
      evaluation,
      attendance
    },
    data() {
      return {
        activeName: 'first'
      };
    },
    created() {
      console.log(this.info)
    },
  };
</script>
<style lang="less" scoped>
.classDetail {
  width: 100%;
  // height: 100%;
  height: calc(100vh - 330px) !important;
  overflow: auto !important;
  background: #fff;
}
 /deep/.el-table {
      width: 100%;
      .el-table__body-wrapper {
          max-height: calc(100vh - 300px);
          overflow-y: auto;

      }
  }
/deep/ .el-tabs__item {
  height: 60px;
}
/deep/ .el-tabs__nav {
  margin-left: 100px;
}
/deep/ .el-tabs__active-bar {
  background: none;
}
</style>